export const getPhoneDigits = (value: string): string => value.replace(/\D/g, "").slice(0, 10);

export const formatPhoneForInput = (value: string): string => {
    const cleaned = getPhoneDigits(value);
    if (cleaned.length <= 3) return cleaned.length ? `(${cleaned}` : "";
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export const formatPhoneForDisplay = (value: string): string => {
    const digits = value.replace(/\D/g, "");
    const core = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
    if (core.length === 10) {
        return `(${core.slice(0, 3)}) ${core.slice(3, 6)}-${core.slice(6)}`;
    }
    return value;
};

export const isValidPhoneNumber = (value: string): boolean => getPhoneDigits(value).length === 10;
